import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime())
    .slice(0, 8);

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              实时同步，热门韩漫及时追更
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            更多更新
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          {latest.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-3 bg-background-50 rounded-lg hover:bg-background-200/50 transition-colors duration-200 cursor-pointer group"
            >
              <span className="w-6 text-center text-sm font-bold text-foreground-400">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 truncate group-hover:text-primary-500 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">{comic.author}</p>
              </div>
              <div className="hidden sm:flex items-center gap-3 text-xs text-foreground-600">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  {comic.rating}
                </span>
                <span>{formatViews(comic.views)}</span>
              </div>
              <div className="hidden md:block">
                <span className="px-2 py-1 bg-primary-50 text-primary-600 text-xs rounded-md font-medium whitespace-nowrap">
                  更新至{comic.chapters}话
                </span>
              </div>
              <div className="text-xs text-foreground-500 whitespace-nowrap">
                {comic.updateTime}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}